import script from "./leaves-employee-table.vue?vue&type=script&setup=true&lang=js"
export * from "./leaves-employee-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__